import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import LoginGuard from './LoginGuard'
import MainLayout from '@/layouts/MainLayout'
import PrivateRoute from './PrivateRoute'
import LazyPage from './LazyPage'

const Login = lazy(() => import('@/pages/login/Login'))
const Home = lazy(() => import('@/pages/home/Home'))
const UserList = lazy(() => import('@/pages/user/UserList'))
const RoleList = lazy(() => import('@/pages/role/RoleList'))
const MenuManagement = lazy(() => import('@/pages/system/MenuManagement'))
const SystemConfig = lazy(() => import('@/pages/system/SystemConfig'))
const SysUserList = lazy(() => import('@/pages/system/SysUserList'))
const Profile = lazy(() => import('@/pages/profile/Profile'))
const WaybillOrder = lazy(() => import('@/pages/wuliuSeaWaybill/index'))
const ShipCompanyList = lazy(() => import('@/pages/vehicle/ShipCompanyList'))
const SailScheduleList = lazy(() => import('@/pages/vehicle/SailScheduleList'))
const PartnerList = lazy(() => import('@/pages/vehicle/PartnerList'))
const CarrierList = lazy(() => import('@/pages/vehicle/CarrierList'))
const CarList = lazy(() => import('@/pages/vehicle/CarList'))
const BillList = lazy(() => import('@/pages/billing/BillList'))
const BillWorkbench = lazy(() => import('@/pages/billing/BillWorkbench'))
const EntityNetBalance = lazy(() => import('@/pages/billing/EntityNetBalance'))
const BackupManagement = lazy(() => import('@/pages/system/BackupManagement'))
const SysConfigDict = lazy(() => import('@/pages/system/SysConfigDict'))

// 创建路由配置
const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginGuard><LazyPage><Login /></LazyPage></LoginGuard>,
  },
  {
    path: '/',
    element: (
      <PrivateRoute>
        <MainLayout />
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: 'home',
        element: <LazyPage><Home /></LazyPage>,
      },
      {
        path: 'user',
        element: <Navigate to="/user/list" replace />,
      },
      {
        path: 'user/list',
        element: <LazyPage><UserList /></LazyPage>,
      },
      {
        path: 'system/role',
        element: <LazyPage><RoleList /></LazyPage>,
      },
      {
        path: 'profile',
        element: <LazyPage><Profile /></LazyPage>,
      },
      {
        path: 'product/list',
        element: <div>商品列表</div>,
      },
      {
        path: 'product/category',
        element: <div>商品分类</div>,
      },
      {
        path: 'order/list',
        element: <div>订单列表</div>,
      },
      {
        path: 'marketing/activity',
        element: <div>活动管理</div>,
      },
      {
        path: 'marketing/coupon',
        element: <div>优惠券</div>,
      },
      {
        path: 'system/menu',
        element: <LazyPage><MenuManagement /></LazyPage>,
      },
      {
        path: 'system/config',
        element: <LazyPage><SystemConfig /></LazyPage>,
      },
      {
        path: 'system/user',
        element: <LazyPage><SysUserList /></LazyPage>,
      },
      {
        path: 'system/backup',
        element: <LazyPage><BackupManagement /></LazyPage>,
      },
      {
        path: 'system/dict',
        element: <LazyPage><SysConfigDict /></LazyPage>,
      },
      {
        path: 'business',
        element: <Navigate to="/business/wuliu_sea_waybill" replace />,
      },
      {
        path: 'business/wuliu_sea_waybill',
        element: <LazyPage><WaybillOrder /></LazyPage>,
      },
      {
        path: 'vehicle/ship_company',
        element: <LazyPage><ShipCompanyList /></LazyPage>,
      },
      {
        path: 'vehicle/ship_schedule',
        element: <LazyPage><SailScheduleList /></LazyPage>,
      },
      {
        path: 'vehicle/partner_company',
        element: <LazyPage><PartnerList /></LazyPage>,
      },
      {
        path: 'vehicle/fleet',
        element: <LazyPage><CarrierList /></LazyPage>,
      },
      {
        path: 'vehicle/vehicle',
        element: <LazyPage><CarList /></LazyPage>,
      },
      // 暂时隐藏，后期启用
      // {
      //   path: 'vehicle/trailer',
      //   element: <div>挂车管理</div>,
      // },
      {
        path: 'billing',
        element: <LazyPage><BillList /></LazyPage>,
      },
      {
        path: 'billing/entity-net-balance',
        element: <LazyPage><EntityNetBalance /></LazyPage>,
      },
      {
        path: 'billing/:id',
        element: <LazyPage><BillWorkbench /></LazyPage>,
      },
    ],
  },
])

export { router }